module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer hidden-print"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('last-activity')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('span', {
    staticClass: "txt-color-white"
  }, [_vm._v("MSB Tech © 2017")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e27ed558"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageFooter.vue
// module id = 1075
// module chunks = 1